module.exports = __webpack_public_path__ + "static/media/logo-camaralagopedra.d242d1b7.png";